
var countries = require('../countries')

export default {
  computed: {
    countries: {
      get() {
        return this.$countries.countries
      },
      set(value) {
        this.$countries.countries = value
      }
    },
    filteredCountries() {
      return countries.getCountries(['CZ', 'SK'], ['CZ', 'SK'])
    },
    allCountries() {
      return countries.getCountries(['CZ', 'SK'])
    },
    regions() {
      return countries.getRegions()
    }
  },
  methods: {
    getCountry(code) {
      return countries.getCountry(code)
    },
    getMask(code) {
      return countries.getMask(code ? code['cca2'] : null)
    },
    getCallingCode(code) {
      return code && code['callingCode'] ? code['callingCode'] : '420'
    },
    getLangCountry(lang) {
      return countries.getLangCountry(lang)
    },
    countriesWithRegion(region) {
      return countries.getCountriesWithRegion(region)
    }
  }
}
